import React from "react";
import CompanyDocuments from "./CompanyDocuments";
import ProductImages from "./ProductImages";

const KnowledgeBase = ({ companyId }) => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold mb-4">Knowledge Base</h2>
        <div className="bg-white rounded-lg shadow p-6">
          <CompanyDocuments companyId={companyId} />
        </div>
      </div>
      <div>
        <h2 className="text-xl font-semibold mb-4">Product Images</h2>
        <div className="bg-white rounded-lg shadow p-6">
          <ProductImages companyId={companyId} />
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBase;
